module.exports = __webpack_public_path__ + "img/GH-corporate-001sp.8cd97b09.png";